import { __rest } from "tslib";
/**
 * 车辆管理-车辆数据查询
 * */
import { createStore } from '@souche-f2e/muji';
import API from '@/services';
import { uniqueArr } from '@/shared/functions';
const initData = {
    globalSearch: {},
    searchData: {},
    searchNum: {},
    tableData: [],
    pageIndex: 1,
    tableTotal: 0,
    isLoading: false,
};
const approveData = {
    approveKey: 'goodsId',
};
const auctionData = {
    auctionKey: 'goodsIdStr',
};
const carData = {
    carKey: 'goodsId',
};
export default createStore({
    state: Object.assign(Object.assign(Object.assign(Object.assign({ pageSize: 20 }, initData), carData), auctionData), approveData),
    effects: {
        // 获取所有状态车辆的总数
        getEveryStateCarNum(params, { state }) {
            let searchParams = state.globalSearch;
            if (Object.keys(params).length > 0) {
                searchParams = params;
            }
            const { provinceCode, cityCode } = searchParams, otherSearch = __rest(searchParams, ["provinceCode", "cityCode"]);
            API.goods.getTabStatisticsCount(Object.assign(Object.assign({}, otherSearch), { localProvinceCode: provinceCode, locationCode: cityCode }))
                .then((res) => {
                this.SET_STATE({
                    searchNum: res,
                });
            });
        },
        // 获取拍卖状态的车辆【预展中，拍卖中（投标中，待竞价，竞价中）】
        updateAuction(index, { state }) {
            const { searchData, pageIndex, pageSize } = state;
            const searchParams = Object.assign(Object.assign({}, searchData), { pageIndex: index || pageIndex, pageSize });
            API.auction.getAuctionStateList(Object.assign({}, searchParams))
                .then((res) => {
                this.SET_STATE({
                    tableData: res.items || [],
                    tableTotal: res.totalNumber || 0,
                    pageIndex: searchParams.pageIndex,
                });
            });
        },
        // 获取结标中车辆
        updateWaitDealCar(index, { state }) {
            const { searchData, pageIndex, pageSize } = state;
            const searchParams = Object.assign(Object.assign({}, searchData), { pageIndex: index || pageIndex, pageSize });
            API.auction.getAuctionTradeList(Object.assign(Object.assign({}, searchParams), { status: 50 })).then((res) => {
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    tableTotal: res.totalNumber || 0,
                    pageIndex: searchParams.pageIndex,
                });
            });
        },
        // 获取流拍车辆
        updateFailAuctionCar(index, { state }) {
            const { searchData, pageIndex, pageSize } = state;
            const searchParams = Object.assign(Object.assign({}, searchData), { pageNum: index || pageIndex, pageSize });
            API.goods.flowAuctionList(Object.assign({}, searchParams)).then((res) => {
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    tableTotal: res.totalNumber || 0,
                    pageIndex: searchParams.pageNum,
                });
            });
        },
        // 获取退回门店车辆
        updateReturnShop(index, { state }) {
            const { searchData, pageIndex, pageSize } = state;
            const searchParams = Object.assign(Object.assign({}, searchData), { pageNum: index || pageIndex, pageSize });
            API.goods.getTradeFailedCars(Object.assign({ tab: 1 }, searchParams)).then((res) => {
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    tableTotal: res.totalNumber || 0,
                    pageIndex: searchParams.pageNum,
                });
            });
        },
        // 获取中标车辆
        updateWinBiddingCarTable(index, { state }) {
            const { searchData, pageIndex, pageSize } = state;
            const searchParams = Object.assign(Object.assign({}, searchData), { pageCurrent: index || pageIndex, pageSize });
            API.order.winBiddingCarTable(Object.assign({}, searchParams)).then((res) => {
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    tableTotal: res.totalNumber || 0,
                    pageIndex: searchParams.pageCurrent,
                });
            });
        },
        // 获取交易结束车辆
        updateDealEndTable(index, { state }) {
            const { searchData, pageIndex, pageSize } = state;
            const searchParams = Object.assign(Object.assign({}, searchData), { pageCurrent: index || pageIndex, pageSize });
            API.order.TradeSuccessCarList(Object.assign({}, searchParams)).then((res) => {
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    tableTotal: res.totalNumber || 0,
                    pageIndex: searchParams.pageCurrent,
                });
            });
        },
        // 获取待买家签署合同
        updateWaitSubscribe(index, { state }) {
            const { searchData, pageIndex, pageSize } = state;
            const searchParams = Object.assign(Object.assign({}, searchData), { pageCurrent: index || pageIndex, pageSize, statusCode: 30 });
            API.order.getWaitSignList(Object.assign({}, searchParams)).then((res) => {
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    tableTotal: res.totalNumber || 0,
                    pageIndex: searchParams.pageCurrent,
                });
            });
        },
        // 获取待付款车辆
        updateWaitPay(index, { state }) {
            const { searchData, pageIndex, pageSize } = state;
            const searchParams = Object.assign(Object.assign({}, searchData), { pageCurrent: index || pageIndex, pageSize });
            API.order.getWaitPayCar(Object.assign({}, searchParams)).then((res) => {
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    tableTotal: res.totalNumber || 0,
                    pageIndex: searchParams.pageCurrent,
                });
            });
        },
        // 获取交付中车辆
        updatePaying(index, { state }) {
            const { searchData, pageIndex, pageSize } = state;
            const searchParams = Object.assign(Object.assign({}, searchData), { pageCurrent: index || pageIndex, pageSize });
            API.order.WaitTransferCarList(Object.assign({}, searchParams)).then((res) => {
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    tableTotal: res.totalNumber || 0,
                    pageIndex: searchParams.pageCurrent,
                });
            });
        },
        // 获取服务费/佣金
        getDefaultCommissionBrokerage(paramsData) {
            const { callback } = paramsData, params = __rest(paramsData, ["callback"]);
            API.auction.getDefaultCommission(params)
                .then((res) => {
                callback(res);
            });
        },
        // desc 重置数据
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign({}, initData), params));
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        resetTableData(state) {
            state.tableData = [];
            state.pageIndex = 1;
            state.tableTotal = 0;
        },
    },
});
